import type { ProductHighlight as ProductHighlightType } from '../../types/products';

const dotColors: Record<string, string> = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-400',
  blue: 'bg-blue-500',
  purple: 'bg-purple-500',
  orange: 'bg-orange-500',
};

interface ProductHighlightProps {
  highlight: ProductHighlightType | null;
}

export function ProductHighlight({ highlight }: ProductHighlightProps) {
  if (!highlight) return null;

  const dotClass = dotColors[highlight.dot] ?? 'bg-gray-400';

  return (
    <div className="mb-1.5 flex items-center gap-1.5 text-xs font-medium tracking-wide text-gray-500">
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${dotClass}`} />
      <span>{highlight.label}</span>
      {highlight.sublabel && (
        <>
          <span className="text-gray-300">|</span>
          <span>{highlight.sublabel}</span>
        </>
      )}
    </div>
  );
}
